// Lives outside Router.js so the unit test can import without pulling in routes.js
// (and the full app graph + CSS imports).

// Narrow on purpose: the full publicRoutes set includes register/OAuth callbacks
// that could mutate state.user and bypass the gate.
export const MFA_GATE_ALLOW_LIST = new Set(['login', 'forgot-password', 'reset-password', 'not-found', 'profile']);

// All three signals required: phone on file, phone confirmed via SMS OTP
// (closes the root-flips-requires_2fa bypass and legacy enrolments with stale
// numbers), and 2FA active on the account.
export const isMfaComplete = user => Boolean(user?.phone && user?.phone_verified && user?.requires_2fa);

// Undefined `user` means /auth/me hasn't resolved; let it through and rely on
// App.vue's render-block + isMfaGated watcher to handle the gate transition.
export const shouldGateMfa = ({ enforceMfaSetup, user, routeName }) => {
  if (!enforceMfaSetup) {
    return false;
  }
  if (!user) {
    return false;
  }
  if (isMfaComplete(user)) {
    return false;
  }
  return !MFA_GATE_ALLOW_LIST.has(routeName);
};
